var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as ngCommon from '@angular/common';
import { NgModule } from '@angular/core';
import { DataTypeService } from './dataType.service';
import { AlarmActionService } from './alarmAction.service';
import { AccessPermissionService } from './access-permission.service';
import { AbpModule } from 'abp-ng2-module/src/abp.module';
var FBoxModule = /** @class */ (function () {
    function FBoxModule() {
    }
    FBoxModule_1 = FBoxModule;
    FBoxModule.forRoot = function () {
        return {
            ngModule: FBoxModule_1,
            providers: [
                DataTypeService,
                AlarmActionService,
                AccessPermissionService
            ]
        };
    };
    var FBoxModule_1;
    FBoxModule = FBoxModule_1 = __decorate([
        NgModule({
            imports: [
                ngCommon.CommonModule,
                AbpModule
            ]
        })
    ], FBoxModule);
    return FBoxModule;
}());
export { FBoxModule };
